<template>
    <VueDatePicker v-if="datePickerMode == 1" v-model="localeRangeVmodelKeeper" placeholder="dd-mm-yyy : dd-mm-yyy" :range="{partialRange: false}" :enable-time-picker="false" model-type="yyyy-MM-dd" :format="rangeFormat" @update:model-value="emitDate" :auto-apply="autoApply" :id="indicator" :name="indicator" :class="indicator" :required="isRequired"></VueDatePicker>
    <VueDatePicker v-else-if="datePickerMode == 2" v-model="localeSingleVmodelKeeper" model-type="yyyy-MM-dd" placeholder="dd-mm-yyyy" :enable-time-picker="false" :format="singleDateFormat" :text-input="{format: 'dd-MM-yyyy'}" :auto-apply="autoApply" @update:model-value="emitDate" :id="indicator" :name="indicator" :class="indicator" :required="isRequired"/>
</template>
<script>
// in case of single date picker modal-type defines the type of the v-model, what should be considered is that :text-input="{format: 'dd-MM-yyyy'}" this prop and specifically format prop indicates 
// writing style in the date input and in this case autoApply should be false because it causes anomalies
export default {
    data(){
        return {
            localeRangeVmodelKeeper: [],
            localeSingleVmodelKeeper: null,
        }
    },
    props: {
        rangeVmodelKeeper: {
            default: [],
            type: Array,
        },
        singleVmodelKeeper: {
            type: String,
            default: null,
        },
        autoApply: {
            type: Boolean,
            default: false, // better to be false
        },
        datePickerMode: {
            type: Number,
            default: 1, // 1 means range picker, 2 - single date
        },
        indicator: {
            type: String,
            default: "",
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        rangeVmodelKeeper: {
            handler(newVal){
                this.localeRangeVmodelKeeper = newVal;
            },
            immediate: true,
        },
        singleVmodelKeeper: {
            handler(newVal){
                this.localeSingleVmodelKeeper = newVal;
            },
            immediate: true,
        }
    },
    methods: {
        rangeFormat(dates){
            let startday, startmonth, startyear;
            let endday, endmonth, endyear;
            if(dates?.length > 0){
                startday = dates[0].getDate();
                startmonth = dates[0].getMonth() + 1;
                startyear = dates[0].getFullYear();
            }
            if(dates?.length > 1){
                endday = dates[1].getDate();
                endmonth = dates[1].getMonth() + 1;
                endyear = dates[1].getFullYear();
            }
            let startStr = startday?`${String(startday).padStart(2, '0')}-${String(startmonth).padStart(2, '0')}-${String(startyear).padStart(4, '0')}`:"";
            let endStr = endday?` : ${String(endday).padStart(2, '0')}-${String(endmonth).padStart(2, '0')}-${String(endyear).padStart(4, '0')}`:"";

            return `${startStr}${endStr}`;
        },
        singleDateFormat(date){
            
            if(date){
                return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getFullYear()).padStart(4, '0')}`;
            }
        },
        emitDate(modelDate){
            this.$emit("update", modelDate);
        },
    },
}
</script>